<template>
  <div class="body">
    <header_index style="background-color: #fff;" v-if="!isMobile()"></header_index>
    <div class="box" v-if="!isMobile()">
      <div class="top1">
        <swiper class="t1box" :options="swiperOption" v-if="top1list && top1list.length > 0" ref="mySwiper">
          <swiper-slide v-for="(item, index) in top1list" :key="index" class="t1item" >
            <img :src="item.r_ResUrl" @click.stop="toopen(item.r_Url)"/>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination" @click="swiperpagination()"></div>
        </swiper>
      </div>
      <Top4 />
    </div>
    <div class="mbox" v-else v-loading="true"></div>
    <footer_index v-if="!isMobile()"></footer_index>
  </div>
</template>
  <script>
import header_index from '../home/header_index';
import footer_index from '../home/footer_index';
import Top4 from './components/top4.vue';
export default {
    components: {
        header_index,
        footer_index,
        Top4,
    },
    data() {
        return {
            player: null,
            isShipin: false,
            shipinTitle: '',
            top1list: [],
            swiperOption: {
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    bulletClass: 'bulletWrite',
                    bulletActiveClass: 'bulletWriteActive',
                    clickable: true,
                },
                autoplay: {
                    delay: 15000,
                    disableOnInteraction: false,
                },
            },
            top2list: [],
            classOption: {
                limitMoveNum: 5,
                direction: 2,
            },
            istest: true,
        };
    },
    created() {
        if (this.isMobile()) {
            window.location.href = this.httphelper.IsDebugH5GP519() + '/?name=popsci';
        } else {
            this.GetCarouselPageList();
        }
    },
    methods: {
        isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
            return flag;
        },
        toopen(url) {
            if (url) {
                window.open(url, '_blank');
            }
        },
        GetCarouselPageList() {
            this.httphelper
                .get('https://pefmapi.gp519.com/api/WebSiteApi/GetCarouselPageList', {
                    uselocation: 1,
                    page: 1,
                    limit: 30,
                })
                .then(res => {
                    if (res.code == 200) {
                        this.top1list = [];
                        this.top1list = res.data;
                    }
                });
        },
    },
};
</script>
  <style lang="scss" scoped>
.body {
    height: 100%;
}

.box {
    min-height: calc(100vh - 384px);
    padding-bottom: 40px;

    .boxtitle {
        width: 100%;
        border-bottom: 1px solid #eee;
        margin: 20px 0;

        .btitle {
            display: inline-block;
            font-size: 26px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #000000;
            line-height: 26px;
            padding: 15px 0;
            border-bottom: 1px solid #000;
        }
    }

    .top1 {
        width: 100%;
        height: 440px;
        background: linear-gradient(180deg, #e0fbf6, #ffffff);
        overflow: hidden;

        .t1box {
            width: 1200px;
            margin: 35px auto 25px;

            .t1item {
                width: 1200px;
                height: 380px;
                border-radius: 20px 20px 20px 20px;
                overflow: hidden;
                background-color: #eee;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .swiper-pagination {
            text-align: left;
            box-sizing: border-box;
            padding-left: 20px;
        }
    }

    .top2 {
        width: 1200px;
        margin: 0 auto;
        height: 50px;
        display: flex;
        align-items: center;

        .laba {
            margin-right: 20px;
        }

        .t2right {
            width: 1159px;
            height: 40px;
            line-height: 40px;
            overflow: hidden;

            .t2rbox {
                display: flex;
                // width: 1500px;
            }

            .t2item {
                // width: 260px;
                margin-right: 40px;
                display: flex;
                align-items: center;

                .dian {
                    width: 10px;
                    height: 10px;
                    background: #cecece;
                    border-radius: 50%;
                    margin-right: 10px;
                }

                .t2box {
                    // width: 300px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    cursor: pointer;
                }
            }

            .t2item:hover {
                color: #0b8586;

                .dian {
                    background: #0b8586 !important;
                }
            }
        }
    }

    .top3 {
        width: 1200px;
        margin: 0 auto;

        .t3row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 30px;

            .t3box {
                width: 585px;
                height: 354px;
                background: #ffffff;
                box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04);
                border-radius: 0px 0px 5px 5px;
                position: relative;

                .t3top {
                    width: 100%;
                    height: 280px;

                    img {
                        width: 100%;
                        height: 280px;
                    }
                }

                .t3tip {
                    position: absolute;
                    top: 0;
                    left: 0;

                    .t3tiptext {
                        width: 120px;
                        position: absolute;
                        font-size: 20px;
                        font-family: Microsoft YaHei;
                        font-weight: bold;
                        color: #ffffff;
                        line-height: 40px;
                        top: 26px;
                        left: -16px;
                        transform: rotate(-46deg);
                        text-align: center;
                    }
                }

                .t3bot {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 74px;
                    padding: 0 20px;

                    .t3btext {
                        display: flex;
                        align-items: center;
                        font-size: 16px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #7a7a7a;
                        line-height: 28px;

                        img {
                            margin-right: 10px;
                        }
                    }

                    .t3bbtn {
                        width: 138px;
                        height: 34px;
                        line-height: 34px;
                        text-align: center;
                        background: #def3f3;
                        color: #0b8586;
                        border: 1px solid #0b8586;
                        border-radius: 17px;
                        cursor: pointer;
                    }
                }
            }

            .t3box:hover {
                position: relative;
                box-shadow: 7px 19px 30px 0px rgba(11, 133, 134, 0.25);

                .t3bbtn {
                    background: #0b8586;
                    color: #fff;
                    border: 1px solid #0b8586;
                }
            }

            ::v-deep .el-alert__title {
                font-size: 16px;
                line-height: 30px;
            }
        }
    }
}

.mbox {
    padding: 20px 3vw;
    background-color: #e5f2ff;
    min-height: 100%;
    box-sizing: border-box;
}

.development {
    display: none;
}
</style>
  